import { type FC, type ReactNode } from 'react'

import { Dialog, DialogContent, type DialogProps, DialogTitle } from 'base-ui'

type ProductPageOdsDialogShellProps = Pick<DialogProps, 'onClose' | 'open'> & {
  children: ReactNode
  title: ReactNode
}

export const ProductPageOdsShellDialog: FC<ProductPageOdsDialogShellProps> = ({
  children,
  onClose,
  open,
  title,
}) => (
  <Dialog
    onClose={onClose}
    open={open}
    slotProps={{
      dialog: { className: 'tablet:w-[40.25rem]' },
    }}
  >
    <DialogTitle onClose={onClose}>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
  </Dialog>
)
